'use strict';

class RulesEditController {
  constructor($q,
              $rootScope,
              $scope,
              $filter,
              $state,
              utils,
              RulesService,
              ToastsService) {
    let $t = $filter('translate');
    let ruleId = $state.params && $state.params.ruleId;
    let userId = $state.params && $state.params.userId;
    let locationId = $state.params && $state.params.locationId;
    let deviceId = $state.params && $state.params.deviceId;
    $scope.isReadOnlyMode = true;
    $scope.userId = userId;
    $scope.locationId = locationId;
    $scope.ruleId = ruleId;
    $scope.deviceId = deviceId;
    $scope.dateFormat = $t('datetime.mdyHM12');
    $scope.rule = utils.getStorageItem('view-rule');
    if ($scope.ruleId !== $scope.rule.id) {
      $scope.rule = null; //if the stored rule doesn't correspond to the url parameter ruleId (means - we better get the rule from API)
    }
    $scope.selection = ($state.params && $state.params.from) || 'user';
    $scope.conditionJoinOperators = [
      { id: 'and', name: $t('rules.and') },
      { id: 'or', name: $t('rules.or') }
    ];
    $scope.conditionJoinOperator = 'and';

    $scope.joinChanged = () => {
      alert($scope.conditionJoinOperator.id);
    };

    $scope.back = () => {
      if ($scope.selection == 'user') {
        $state.go('main.users.edit', { tab: 'rules', userId: $scope.userId });
        $rootScope.$emit('refreshChooseMenuEvent', 'users');
      } else if ($scope.selection == 'device') {
        $state.go('main.devices.edit', { tab: 'rules', deviceId: $scope.deviceId, locationId: $scope.locationId });
        $rootScope.$emit('refreshChooseMenuEvent', 'devices');
      } else if ($scope.selection === 'location') {
        $state.go('main.locations.edit', { tab: 'rules', locationId: $scope.locationId });
        $rootScope.$emit('refreshChooseMenuEvent', 'locations');
      } else {
        $state.go('main.devices.list');
        $rootScope.$emit('refreshChooseMenuEvent', 'devices');
      }
    };

    $scope.addCondition = () => {
      //add selected state to the states collection (conditions)
      if ($scope.newState) {
        if (!$scope.rule.states) {
          $scope.rule.states = {};
        }
        if (!$scope.rule.states.state) {
          $scope.rule.states.state = [];
        }
        if (!$scope.rule.states.and) {
          $scope.rule.states.and = [];
        }

        if ($scope.conditionJoinOperator === 'and') {
          if ($scope.rule.states.and.length === 0) {
            $scope.rule.states.and.push({ state: [] });
          }
          if (!$scope.rule.states.and[0].state) {
            $scope.rule.states.and[0].state = [];
          }
          $scope.rule.states.and[0].state.push($scope.newState);
        } else {
          $scope.rule.states.state.push($scope.newState);
        }
        $scope.removeStateFromAvailableStates($scope.newState);
      }
    };
    $scope.removeCondition = (state, isAndJoin) => {
      if (!isAndJoin) {
        removeItemFromItemsList(state, $scope.rule.states.state);
      } else {
        removeItemFromItemsList(state, $scope.rule.states.and[0].state);
      }
      $scope.states.push(state);
    };
    $scope.removeStateFromAvailableStates = (state) => {
      removeItemFromItemsList(state, $scope.states);
      $scope.newStateId = $scope.states.length > 0 ? $scope.states[0].id : -1;
    };

    $scope.addAction = () => {
      //add selected state to the states collection (conditions)
      if ($scope.newAction) {
        if (!$scope.rule.actions) {
          $scope.rule.actions = [];
        }

        $scope.rule.actions.push($scope.newAction);

        $scope.removeActionFromAvailableActions($scope.newAction);
      }
    };
    $scope.removeActionFromAvailableActions = (action) => {
      removeItemFromItemsList(action, $scope.actions);
      $scope.newActionId = $scope.actions.length > 0 ? $scope.actions[0].id : -1;
    };
    $scope.removeAction = (action) => {
      removeItemFromItemsList(action, $scope.rule.actions);
      $scope.actions.push(action);
    };

    $scope.saveRule = () => {
      if ($scope.rule && $scope.rule.id) {
        let rule = $scope.rule;
        //Save existing rule. To do that we need to perform magic transformation of the entities we got from
        //'get' APIs into entities that can be accepted by 'put' APIs.
        //TODO: Refactor values used for parameters into UI (user) selected values that are assigned by user
        let ruleModel = {
          rule: {
            name: rule.name,
            status: rule.status,
            timeZone: rule.timeZone,
            hidden: rule.hidden,
            trigger: {
              id: rule.trigger.id,
              parameter: rule.trigger.parameters.map((tp) => {
                return { name: tp.name, value: tp.values[0].id };
              })
            },
            actions: {
              //Project each 'actions' array item into apropriate form to submit to api
              action: !rule.actions ? [] : rule.actions.map((a) => {
                return {
                  id: a.id,
                  parameter: a.parameters.map((ap) => {
                    return {
                      name: ap.name,
                      value: ap.value || ap.values[0].id
                    };
                  })
                };
              })
            },
            states: {
              //Project each 'state' array item into apropriate form to submit to api
              state: !rule.states.state ? [] : rule.states.state.map((s) => {
                return {
                  id: s.id,
                  parameter: s.parameters.map((sp) => {
                    return {
                      name: sp.name,
                      value: sp.values[0].id
                    };
                  })
                };
              }),
              //Project each 'and' array item into apropriate form to submit to api
              and: !rule.states.and ? [] : rule.states.and.map((andItem) => {
                andItem.state = andItem.state.map((andItemState) => {
                  return {
                    id: andItemState.id,
                    parameter: andItemState.parameters.map((andItemStateParam) => {
                      return {
                        name: andItemStateParam.name,
                        value: andItemStateParam.values[0].id
                      };
                    })
                  };
                });
                return andItem;
              })
            }
          }
        };

        return RulesService
          .updateRule(rule.id, ruleModel, { locationId: $scope.locationId })
          .then(function(data) {
            ToastsService.success();
            initPage();
            utils.setStorageItem('view-rule', $scope.rule);
            return data;
          }, (data) => {
            //ToastsService.error(data.resultCodeDesc, $t("rules.ruleSavingError"), "error");
            console.error(data);
            return $q.reject(data);
          });
      } else {
        //Otherwise save new rule

      }
    };

    function removeCurrentActionsFromAvailableActions() {
      return $q((resolve, reject) => {
        if ($scope.rule.actions) {
          for (let i = 0; i < $scope.rule.actions.length; i++) {
            $scope.removeActionFromAvailableActions($scope.rule.actions[i]);
          }
        }
        resolve();
      });
    }

    function removeCurrentStatesFromAvailableStates() {
      return $q((resolve, reject) => {
        if ($scope.rule.states) {
          let arraysToScan = [];
          if ($scope.rule.states.state) {
            arraysToScan.push($scope.rule.states.state);
          }
          if ($scope.rule.states.and && $scope.rule.states.and.state) {
            arraysToScan.push($scope.rule.states.and.state);
          }
          for (let array of arraysToScan) {
            for (let i = 0; i < array.length; i++) {
              $scope.removeStateFromAvailableStates($scope.rule.states[i]);
            }
          }
        }
        resolve();
      });
    }

    let getRuleById = function() {
      if ($scope.ruleId === -1) {
        //New rule creation
        $scope.rule = {};
        return $q.resolve($scope.rule);
      }

      //if the cached rule is null or cached rule's Id is not equal to the requested ruleId, get the rule from api
      if ($scope.rule == null || $scope.ruleId !== $scope.rule.id) {
        return RulesService
          .getRule($scope.ruleId, { locationId: $scope.locationId, details: true })
          .then(function(data) {
            if (!data || !data.rules) {
              return $q.reject(data);
            }
            return data.rules[0];
          })
          .then(function(rule) {
            $scope.rule = rule;
            //Flatten 'and' states collections into one array
            // if(rule.states.and) {
            //   let flattenedStates = rule.states.and
            //     .map((a) => { return a.state; })
            //     .reduce((result, current) => { return result.concat(current); }, []);
            //   $scope.rule.states.and = [{ state: flattenedStates }]
            // }

            return $scope.rule;
          })
          .catch(function(err) {
            console.log(err);
            return $q.reject(err);
          });
      } else {
        return $q.resolve($scope.rule);
      }

    };

    function initPage() {
      $scope.ruleLoading = true; //to indicate rule is being loaded
      initRuleDetails()
        .then(getRuleById)
        .then(function(ruleModel) {
          return $q.all([
            removeCurrentActionsFromAvailableActions(),
            removeCurrentStatesFromAvailableStates()
          ]);
        })
        .then(function() {
          $scope.ruleLoading = false;
        });
    }

    initPage();

    function initRuleDetails() {
      //Additional processing of the rule here to build conditions and actions lists

      return RulesService.getRulePhrases({ locationId: $scope.locationId })
        .then(function(data) {
          if (!data || data.resultCode !== 0 || !data.triggers) {
            return $q.reject(data);
          }
          $scope.triggers = data.triggers;
          $scope.states = data.states;
          $scope.actions = data.actions;
          return data;
        })
        .catch(function(err) {
          console.log(err);
          return $q.reject(err);
        });

    }

    function removeItemFromItemsList(item, items) {
      let itemIndex = items.indexOf(item);
      if (itemIndex === -1) {
        //See if it's another object but still describing the same item
        let founds = items.filter((element, i) => {
          if (element.id === item.id) {
            itemIndex = i;
            return true;
          }
        });
      }
      //Now remove the found item from the array of available items
      if (itemIndex >= 0) {
        items.splice(itemIndex, 1);
      }
    }

  }
}

export default angular
  .module('main.rulesEdit.controller', [])
  .controller('RulesEditController', RulesEditController)
  .name;
